import { DownloadIcon, SpinnerIcon, CheckIcon } from "../icons";

/*
 * The download affordance button. Always renders all three icon slots
 * (rest / spinner / check) + the label; downloads.css shows the right one from
 * the is-loading / is-done classes, matching the mockup's icon state machine.
 * The label swaps to "Saved" on done. Renders as an <a> by default (the real
 * rails 302 drives the file); the "Download all" hero renders as a <button>
 * (no href) and owns its click.
 */
const DownloadButton = ({
  as: Tag = "a",
  state = "rest", // 'rest' | 'loading' | 'done'
  variant = "part", // 'part' | 'primary'
  label,
  className = "",
  ...rest
}) => {
  const classes = [
    "btn",
    variant === "primary" ? "btn-primary" : "btn-part",
    state === "loading" ? "is-loading" : "",
    state === "done" ? "is-done" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  // The primary buttons carry btn-ico-dl for the on-hover downward nudge.
  const iconClass = variant === "primary" ? "btn-ico btn-ico-dl" : "btn-ico";
  return (
    <Tag className={classes} {...rest}>
      <span className={iconClass}>
        <DownloadIcon />
      </span>
      <span className="lbl">{state === "done" ? "Saved" : label}</span>
      <span className="spin">
        <SpinnerIcon />
      </span>
      <span className="done-ico">
        <CheckIcon />
      </span>
    </Tag>
  );
};

export default DownloadButton;
